<div class="form-card">
    <form class="form">
        <app-input *ngIf="isUserPassword" [inputModel]="password.senhaAtualInputModel" (isInputValid)="setFormStatus($event, 'currentPassword')" [(value)]="password.senhaAtual"></app-input>
        <app-input *ngIf="isUserPassword" [inputModel]="password.senhaNovaInputModel" (isInputValid)="setFormStatus($event, 'newPassword')" [(value)]="password.senhaNova"></app-input>
        <app-input *ngIf="isUserPassword" [inputModel]="password.confirmarSenhaNovaInputModel" (isInputValid)="setFormStatus($event, 'confirmNewPassword')" [(value)]="password.confirmarSenhaNova"></app-input>
        
        <app-input *ngIf="isDependentPassword"  [inputModel]="password.meepCardSenhaNovaInputModel" (isInputValid)="setFormStatus($event, 'newPassword')" [(value)]="password.senhaNova"></app-input>
        <app-input *ngIf="isDependentPassword"  [inputModel]="password.meepCardConfirmarSenhaNovaInputModel" (isInputValid)="setFormStatus($event, 'confirmNewPassword')" [(value)]="password.confirmarSenhaNova"></app-input>

        <app-input *ngIf="isDependentCardName"  [inputModel]="password.cardNameInputModel" (isInputValid)="setFormStatus($event, 'cardName')" [(value)]="password.cardName"></app-input>
        <app-input *ngIf="isDependentCardName"  [inputModel]="password.cardNameConfirmInputModel" (isInputValid)="setFormStatus($event, 'confirmCardName')" [(value)]="password.cardNameConfirm"></app-input>
    
        
        <!-- <button (click)="removeCardName()" *ngIf="isDependentCardName" mat-raised-button class="confirma">
            Remover Usuário
        </button> -->
        <button (click)="changePassword()" mat-raised-button class="trocar-senha">
            Confirmar
        </button>
    </form>
    
</div>


// WEBPACK FOOTER //
// /usr/src/app/src/app/components/change-password/change-password.component.html